/**
 * Terms of Service - English v2
 * 
 * Effective Date: February 1, 2026
 */
export const TERMS_V2_EN = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "en",
    title: "Terms of Service",
    content: `
Spot Go Terms of Service

Last Updated: February 1, 2026 (KST)

These Terms of Service ("Terms") govern your use of the Spot Go game ("Service") provided by the Developer ("we", "us"). By accessing or using the Service, you agree to these Terms.

1. Account

Your account is linked to your Pi Network identity. You are responsible for all activities that occur under your account, including compliance with these Terms.

1-1. Public Display and Storage of Nickname

Your Pi Network nickname and user ID are received through the Pi Network login process and stored securely on our servers. These identifiers are used to maintain your account, display rankings (e.g., leaderboards and events), and verify usage history. Your nickname may be publicly displayed to other users within the Service.

2. Virtual Goods

The Service may include virtual goods ("Virtual Goods"). These are not real currency.

• STAR: Points earned through ad viewing, app usage, event participation, etc.
• TICKET: Items used for app usage, post registration, etc.
• SPOT: Points earned within the Service through LAND visits, content creation (posts, stores, etc.), achievement completion, etc., currently used only for in-Service rankings, statistics, and visual effects, and having no monetary value.

Except where required by applicable law, all purchases of Virtual Goods are final and non-refundable. We reserve the absolute right to manage, regulate, control, modify, or remove Virtual Goods at any time with or without notice.

3. User Conduct

You agree not to misuse the Service. This includes:
• Cheating, bug exploitation
• Use of automated software (bots)
• Decompiling software
• Attempting to disrupt Service integrity
• Registering false information
• Posting inappropriate content such as profanity, slander, or obscene material
• Posting speculative, price-related, or false/exaggerated information unrelated to the Service's purpose (location-based information sharing)

4. Content Management

The copyright of posts (Spots) registered by users belongs to those users. We may delete posts without prior notice if they violate laws, infringe on others' rights, contain false information, or include inappropriate content.

5. Reporting and Sanctions

• Posts that receive reports from other users beyond a certain threshold may be automatically hidden.
• Accounts that repeatedly receive reports may have their service usage restricted.
• Accounts that repeatedly file false or malicious reports may also be sanctioned.

6. Intellectual Property

The Service (including all content, features, and technology) is the exclusive property of the Developer. You are granted a limited, non-exclusive, non-transferable license to access and use the Service for personal, non-commercial purposes.

7. Termination

We may immediately terminate or suspend your access to the Service without prior notice or liability if you violate the Terms. Upon termination of access, all data related to the Service may be deleted.

8. Disclaimer of Warranties and Limitation of Liability

The Service is provided "as is" and "as available." To the maximum extent permitted by law, we disclaim all warranties of any kind. The Developer is not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use or inability to use the Service.

9. Governing Law and Dispute Resolution

These Terms are governed by the laws of the Republic of Korea, regardless of conflict of law provisions. Any disputes arising from these Terms are subject to the exclusive jurisdiction of the Suwon District Court.

10. Changes to Terms

We reserve the right to modify these Terms at any time. Changes will be notified by posting new Terms within the Service or on the official website.

11. Contact Us

If you have questions, please contact: lukep81@painori.com
`.trim()
};
